module.exports = __webpack_public_path__ + "img/database_sign.b2a9195e.png";